/**
 * Interfaces relacionadas a BNCC (Base Nacional Comum Curricular)
 */

export interface Bncc {
  ID_BNCC: number;
  /** ID do plano de aula quando o BNCC está vinculado (opcional) */
  ID_PLANO_AULA?: number;
  /** ID da habilidade do plano de aula quando vinculado (opcional) */
  ID_PLANO_AULA_HAB?: number;
  CAMPO1: string;
  CAMPO2: string;
  CAMPO3: string;
  CAMPO4: string;
  CAMPO5: string;
  CAMPO6: string;
  CAMPO7: string;
  CAMPO8: string;
  CAMPO9: string;
  CAMPO10: string;
  CAMPO11: string;
  CAMPO12: string;
  CAMPO13: string;
  CAMPO14: string;
  CAMPO15: string;
  CAMPO16: string;
  CAMPO17: string;
}

export interface Config {
  EXIBE_CAMPO1: boolean;
  TITULO_CAMPO1: string;
  EXIBE_CAMPO2: boolean;
  TITULO_CAMPO2: string;
  EXIBE_CAMPO3: boolean;
  TITULO_CAMPO3: string;
  EXIBE_CAMPO4: boolean;
  TITULO_CAMPO4: string;
  EXIBE_CAMPO5: boolean;
  TITULO_CAMPO5: string;
  EXIBE_CAMPO6: boolean;
  TITULO_CAMPO6: string;
  EXIBE_CAMPO7: boolean;
  TITULO_CAMPO7: string;
  EXIBE_CAMPO8: boolean;
  TITULO_CAMPO8: string;
  EXIBE_CAMPO9: boolean;
  TITULO_CAMPO9: string;
  EXIBE_CAMPO10: boolean;
  TITULO_CAMPO10: string;
  EXIBE_CAMPO11: boolean;
  TITULO_CAMPO11: string;
  EXIBE_CAMPO12: boolean;
  TITULO_CAMPO12: string;
  EXIBE_CAMPO13: boolean;
  TITULO_CAMPO13: string;
  EXIBE_CAMPO14: boolean;
  TITULO_CAMPO14: string;
  EXIBE_CAMPO15: boolean;
  TITULO_CAMPO15: string;
  EXIBE_CAMPO16: boolean;
  TITULO_CAMPO16: string;
  EXIBE_CAMPO17: boolean;
  TITULO_CAMPO17: string;
  TITULO_PESQUISA: string;
}

export interface ListaPesquisaBNCC {
  CONFIG: Config[];
  BNCC: Bncc[];
  FILTRO?: FiltroBncc[];
}

export interface FiltroBncc {
  VALOR: string;
}

/**
 * Request para buscar BNCC
 */
export interface GetBNCCRequest {
  disciplina: {
    CDDISC: number;
    ETAPA_BNCC: number;
    IDAREACOMPONENTE: number;
  };
  planoDeAula: {
    CDESCOLA: number;
    EXERC: string | number;
    BIMESTRE: number;
    CPF: string;
    ID_TURMA: number;
  };
  DATABASE: string;
  FILTRO?: string;
  VALOR?: string;
}
